import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './NoDealsState.css';

// Shown when the deal feed is empty (no search term). Instead of a dead end,
// it keeps visitors on the site: subscribe for alerts, or read the blog.
const NoDealsState = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/blog/recent?limit=3')
      .then((res) => {
        if (!cancelled && Array.isArray(res.data)) setPosts(res.data);
      })
      .catch(() => { /* blog links are optional; keep the empty state usable */ });
    return () => { cancelled = true; };
  }, []);

  const scrollToSubscribe = () => {
    const target = document.getElementById('subscribe');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const input = target.querySelector('input[type="email"]');
      if (input) input.focus({ preventScroll: true });
    }
  };

  return (
    <section className="container no-deals" aria-labelledby="no-deals-title">
      <div className="no-deals__card">
        <div className="no-deals__icon" aria-hidden="true">🛍️</div>
        <h2 id="no-deals-title" className="no-deals__title">Fresh deals are on the way</h2>
        <p className="no-deals__text">
          We&apos;re refreshing our deal list right now. Get the next batch of promo codes and
          price drops in your inbox as soon as they&apos;re live.
        </p>
        <button type="button" className="btn btn-primary no-deals__cta" onClick={scrollToSubscribe}>
          Notify me about new deals
        </button>
      </div>

      {posts.length > 0 && (
        <div className="no-deals__blog">
          <h3 className="no-deals__blog-title">In the meantime, save more with these guides</h3>
          <ul className="no-deals__posts">
            {posts.map((post) => (
              <li key={post.slug}>
                <Link to={`/blog/${post.slug}`} className="no-deals__post">
                  <span className="no-deals__post-title">{post.title}</span>
                  {post.readTime && <span className="no-deals__post-meta">{post.readTime}</span>}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/blog" className="no-deals__all-posts">Browse all guides →</Link>
        </div>
      )}
    </section>
  );
};

export default NoDealsState;
